import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../shared/shared.module';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { RawImageManageComponent, RawImagePendingGroupedComponent } from './components/raw-image';
import { EditorRoutingModule } from './editor-routing.module';
import { EditorComponent } from './editor.components';
import { RawImageService } from './services/raw.image.service';

@NgModule({
    declarations: [
        EditorComponent,
        DashboardComponent,
        RawImagePendingGroupedComponent,
        RawImageManageComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        EditorRoutingModule,
        NgbModule,
      ],
    providers: [
        RawImageService,
    ],
})

export class EditorModule { }
